import { Link } from "react-router-dom";

const Error = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center text-center text-white error-page p-5">
      <h2 className="mb-2 text-white">Error: Page Not Found</h2>
      <h1 className="py-5">
        4<span className="text-white">0</span>4
      </h1>
      <h2 className="text-white">This Page Isn’t Available</h2>
      <Link to="/" className="text-decoration-none">
        <button className="btn error-btn rounded-0  shadow-none m-5">
          Go To Homepage
        </button>
      </Link>
    </div>
  );
};

export default Error;
